import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Logout = () => {
    const navigate = useNavigate();
    var LogoutMsg = ''
    const LogoutHandler = () => {
        let company_id = localStorage.getItem("company_id") ?? "";

        if (localStorage.length > 0 && (localStorage.getItem("LogoutType") !== '' || localStorage.getItem("LogoutType") !== null)){
            axios.post("/api/Auth/Logout", new URLSearchParams({
                type: localStorage.getItem("LogoutType")
            }),
            { withCredentials: true })
            .then(function (response) {
                
            })
            .catch(function (error) {
                console.log("네트워크 실패", error);
            })
            .then(function () {
                // 항상 실행
                localStorage.clear();
                if(company_id == ''){
                    navigate("/Login");
                }else{
                    navigate("/Login/"+company_id);
                }
            });
        }
    }

    if(localStorage.getItem("LogoutType") === 'F'){
        LogoutMsg = '장시간 활동이 없어 자동으로 로그아웃 되었습니다.'
    }else if(localStorage.getItem("LogoutType") === 'N'){
        LogoutMsg = '로그인 후 정상적인 사용이 가능합니다.'
    }else if(localStorage.getItem("LogoutType") === 'C'){
        //LogoutMsg = '정상적으로 로그아웃 되었습니다.'
    }else if(localStorage.getItem("LogoutType") === 'S'){
        //LogoutMsg = '보안상의 이유로 로그아웃 되었습니다.'
    }else if(localStorage.getItem("LogoutType") === 'J'){
        LogoutMsg = '중복 로그인으로 확인되어 로그아웃 되었습니다.'
    }else{
        LogoutMsg = '강제 로그아웃'
    }

    if(LogoutMsg !== ''){
        Swal.fire({
            title: '<p style="color:red">접속 오류</p>',
            text: LogoutMsg,
            confirmButtonText: '확인',
            confirmButtonColor: '#7066e0',
                        timer:5000,
                        timerProgressBar: true
        }).then((value) => {
            LogoutHandler();
        });
    }else{
        LogoutHandler();
    }
}

export default Logout;
